export default "__VITE_ASSET__CnH7wZJc__"